/** Owner login alias — reuses the staff email+password form. */
import StaffLoginPage from '@/pages/LoginPage';
export default function OwnerLoginPage() { return <StaffLoginPage />; }
